export const PUBLIC_FILES_FOLDER = "public_files";
export const LOCALSTORAGE_KEY = Object.freeze({
  AUTH_TOKEN: "authToken",
  USER: "user",
});
